import { AxiosError } from "axios";

import httpRequest from "@/auth/http-client";
import { IChat } from "@/interfaces/chat.interfaces";

const baseConversationUrl = "api/v1/conversation";

export async function getAllConversations(platformId: number): Promise<IChat[]> {
  try {
    // Usar o token do usuário logado via httpRequest (interceptor injeta Authorization/CustomerId)
    const apiUrl = `${baseConversationUrl}/all/${platformId}`;
    const conversations = await httpRequest.get<IChat[]>(apiUrl);
    return conversations || [];
  } catch (error) {
    if (error instanceof AxiosError) {
      // Se for 404 ou outro erro, retornar array vazio ao invés de quebrar
      if (error.response?.status === 404) {
        return [];
      }
      throw new Error(error.response?.data?.message || "Failed to fetch conversations");
    }
    throw new Error("Failed to fetch conversations");
  }
}
